<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.7471 6.05122C16.9912 6.2953 16.9912 6.69103 16.7471 6.93511L7.63139 16.0508C7.51418 16.168 7.35521 16.2339 7.18945 16.2339C7.02368 16.2339 6.86471 16.168 6.7475 16.0508L3.25141 12.5546C3.00734 12.3105 3.00734 11.9148 3.25143 11.6707C3.49551 11.4266 3.89124 11.4266 4.13531 11.6707L7.18946 14.725L15.8632 6.05122C16.1073 5.80714 16.503 5.80714 16.7471 6.05122Z"
    fill="#00C853" />
</template>
